import { publicApiRequest } from '../../../../lib/hooks/axios-instance'
import { addTokenToHeaders } from '../../../../lib/utils/addTokenReq'
import {
  ApproveIndividualRequestType,
  ApproveOrganizationRequestType,
  ApproveResponseType,
  GetApprovalRequestResponseType,
  GetApprovalRequestType,
} from '../../../../types/approve-request.type'

export class ApprovalRequestsService {
  /**
   * GET
   * Get list of accounts needing approval on super admin dashboard
   * @returns Promise<any>
   */
  public async getApprovalRequests(data: GetApprovalRequestType) {
    return await (
      await publicApiRequest()
    ).get<GetApprovalRequestResponseType>(
      '/auth/users/suspended-and-inactive',
      addTokenToHeaders(data.token),
    )
  }

  /**
   * POST
   * validate organization request
   * @returns Promise<any>
   */
  public async approveOrganizationRequest(data: ApproveOrganizationRequestType) {
    return await (
      await publicApiRequest()
    ).post<ApproveResponseType>(
      '/auth/organisations/validate/org-request',
      {
        organisationId: data.organisationId,
        email: data.email,
      },
      addTokenToHeaders(data.token),
    )
  }
  /**
   * PATCH
   * validate user request
   * @returns Promise<any>
   */
  public async approveIndividualRequest(data: ApproveIndividualRequestType) {
    return await (
      await publicApiRequest()
    ).patch<ApproveResponseType>(
      `/auth/users/activate-user-account/${data.email}`,
      null,
      addTokenToHeaders(data.token),
    )
  }
}
